import { __assign, __awaiter, __generator } from "tslib";
import { CheckoutNavigationService } from '../../../services/CheckoutNavigationService/CheckoutNavigationService';
import { ModalType } from '../../../services/CheckoutNavigationService/constants';
import { StoreMetaDataApi } from '../../../apis/StoreMetaDataApi/StoreMetaDataApi';
export var getCheckoutEligibility = function (_a) {
    var context = _a.context;
    return function (checkoutDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isPremium, delivery, canPay, _b, isLiveSite, reason;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, context.eCommerceSettingsService.getEcommerceSettings()];
                case 1:
                    _a = _c.sent(), isPremium = _a.isPremium, delivery = _a.delivery;
                    _b = !(checkoutDetails === null || checkoutDetails === void 0 ? void 0 : checkoutDetails.requirePayment);
                    if (_b) return [3 /*break*/, 3];
                    return [4 /*yield*/, hasPaymentMethods(context.siteStore)];
                case 2:
                    _b = (_c.sent());
                    _c.label = 3;
                case 3:
                    canPay = _b;
                    isLiveSite = !(context.siteStore.isPreviewMode() || context.siteStore.isEditorMode());
                    if (!delivery.canBusinessShip && (checkoutDetails === null || checkoutDetails === void 0 ? void 0 : checkoutDetails.hasShippableItems)) {
                        reason = 'CannotShip';
                    }
                    else if (!canPay) {
                        reason = 'NoConnectedPaymentMethods';
                    }
                    else if (!isPremium) {
                        reason = 'NotPremium';
                    }
                    else if (!isLiveSite) {
                        reason = 'NotInLiveSite';
                    }
                    return [2 /*return*/, __assign({ canCheckout: !reason }, { reason: reason })];
            }
        });
    }); };
};
function hasPaymentMethods(siteStore) {
    return __awaiter(this, void 0, void 0, function () {
        var storeMetaDataApi, metadata;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storeMetaDataApi = new StoreMetaDataApi({ siteStore: siteStore, origin: '' });
                    return [4 /*yield*/, storeMetaDataApi.getStoreMetaData()];
                case 1:
                    metadata = _a.sent();
                    return [2 /*return*/, metadata.hasCreatedPaymentMethods];
            }
        });
    });
}
var OWNER_REASON_TO_MODAL_TYPE = {
    CannotShip: ModalType.SetShipping,
    NoConnectedPaymentMethods: ModalType.SetPayment,
    NotPremium: ModalType.UpgradeToPremium,
    NotInLiveSite: ModalType.NotInLiveSite,
};
var REASON_TO_MODAL_TYPE = {
    CannotShip: ModalType.NoOnlinePayments,
    NoConnectedPaymentMethods: ModalType.NoOnlinePayments,
    NotPremium: undefined,
    NotInLiveSite: undefined,
};
export var handleCheckoutEligibility = function (_a) {
    var context = _a.context;
    return function (checkoutEligibility, options) { return __awaiter(void 0, void 0, void 0, function () {
        var checkoutNavigationService, isOwnerOrNotInLiveSite, modalType, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkoutEligibility.reason) {
                        return [2 /*return*/, { canNavigateToCheckout: true }];
                    }
                    checkoutNavigationService = new CheckoutNavigationService(__assign(__assign({}, context), { origin: options.origin }));
                    isOwnerOrNotInLiveSite = context.siteStore.isOwner || context.siteStore.isPreviewMode() || context.siteStore.isEditorMode();
                    modalType = isOwnerOrNotInLiveSite
                        ? OWNER_REASON_TO_MODAL_TYPE[checkoutEligibility.reason]
                        : REASON_TO_MODAL_TYPE[checkoutEligibility.reason];
                    if (!modalType) {
                        return [2 /*return*/, { canNavigateToCheckout: true }];
                    }
                    return [4 /*yield*/, checkoutNavigationService.openLegacyCartModal(modalType, {}, true)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, { canNavigateToCheckout: modalType === ModalType.UpgradeToPremium && Boolean(response === null || response === void 0 ? void 0 : response.proceed) }];
            }
        });
    }); };
};
//# sourceMappingURL=checkoutEligibility.js.map